module.exports = __webpack_public_path__ + "media/images/about__how-do-we-make-money-37f98bb336991746cf5f0d7952f22f21.jpg";